import axiosInstance from "../helpers/axiosInstance";

const API_URL = "https://estimationapi.corpfield.com/staff/customers";

export const creategstapi = async (request) => {
    const response = await axiosInstance.post(API_URL, request);
    return response.data;
};

export const createdelieveryapi = async (request) => {
    const response = await axiosInstance.post(API_URL, request);
    return response.data;
};

export const createwarrentyapi = async (request) => {
    const response = await axiosInstance.post(API_URL, request);
    return response.data;
};

export const createreferenceapi = async (request) => {
    const response = await axiosInstance.post(API_URL, request);
    return response.data;
};

export const createbankapi = async (request) => {
    const response = await axiosInstance.post(API_URL, request);
    return response.data;
};

export const createcompanyapi = async (request) => {
    const response = await axiosInstance.post(API_URL, request);
    return response.data;
};
